import { WebsiteScriptCodeDisplayItem } from '../api/WebsiteScriptCodeDisplayItem';
import { WebsiteScriptCodeInputItem } from '../api/WebsiteScriptCodeInputItem';

declare module '../api/WebsiteScriptCodeDisplayItem' {
    namespace WebsiteScriptCodeDisplayItem {
        let ConvertToInputItem: typeof convertToInputItem;
    }
}

WebsiteScriptCodeDisplayItem.ConvertToInputItem = convertToInputItem;

function convertToInputItem(displayItem: WebsiteScriptCodeDisplayItem): WebsiteScriptCodeInputItem {
    return new WebsiteScriptCodeInputItem({
        Title: displayItem.Title,
        ScriptCode: displayItem.ScriptCode,
    });
}
